let skipPathname = null;

export const skipScrollToTop = (pathname) => {
  skipPathname = pathname;
};

export const shouldSkipScrollToTop = (pathname) => {
  if (skipPathname === pathname) return true;

  skipPathname = null;

  return false;
};
